import { useSelector } from 'react-redux';
import { ClientSubscription } from '@models/Opa';
import { RetailerClient } from '@models/RetailerClient';
import { ProductType } from '@pages/product-analyzer/Product';
import { getSubscriptionDetailsByProductType } from '@utils/AppSubscriptionUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { getUniqueSubscriptions } from './MultiBannerRetailerSelectorUtils';
import { actions, elements } from '@ecosystem/newron-design-system';
import * as styles from './MultiBannerRetailerSelector.module.scss';

interface Props {
  retailerClients: RetailerClient[];
  onChangeHandler: (subscription: ClientSubscription[]) => void;
  productType: ProductType;
}

const MultiBannerRetailerSelector: React.FC<Props> = ({ retailerClients, onChangeHandler, productType }) => {
  const pagesConfig = usePageConfig();
  let currentRetailerClientState: any;
  const retailerClientState = useSelector((state: any) => state.retailerClient);
  const hitlistsRetailerClientState = useSelector((state: any) => state.hitlistsRetailerClient);
  const sellerInsightsRetailerClientState = useSelector((state: any) => state.sellerInsightsRetailerClient);
  const marketPremiumRetailerClientState = useSelector((state: any) => state.marketPremiumRetailerClient);
  const { Menu } = actions;
  const { Icon } = elements;
  const { ChevronDown } = Icon.icons;
  switch (productType) {
    case ProductType.PerformanceAnalyzer:
    case ProductType.RetailKad:
      currentRetailerClientState = retailerClientState;
      break;
    case ProductType.MarketPremium:
      currentRetailerClientState = marketPremiumRetailerClientState;
      break;
    case ProductType.SellerInsights:
      currentRetailerClientState = sellerInsightsRetailerClientState;
      break;
    default:
      currentRetailerClientState = hitlistsRetailerClientState;
  }

  const getOptions = () => {
    return retailerClients.map((retailerClient) => {
      return {
        label: retailerClient.clientName,
        value: retailerClient.clientId,
      };
    });
  };

  const defaultValue = getOptions().filter((option) => option.value === +currentRetailerClientState.clientId);

  const onChange = (event: any) => {
    const clientId = event.value;

    const subscriptionDetails = getSubscriptionDetailsByProductType(productType, pagesConfig);
    const currentClientSubscription = subscriptionDetails.currentSubscription;

    const uniqueSubscriptions: ClientSubscription[] = getUniqueSubscriptions(currentClientSubscription, clientId);
    onChangeHandler(uniqueSubscriptions);
  };

  return (
    <div className={styles.MultiBannerRetailerSelector__Container}>
      <Menu isDisabled={false}>
        <Menu.Button testId={'retailer-button-menu'} textColor={'default'}>
          {defaultValue[0]?.label}
          <Icon color="default">
            <ChevronDown />
          </Icon>
        </Menu.Button>
        <Menu.List>
          {getOptions().map((retailerClient) => {
            return (
              <Menu.Item
                key={retailerClient.value}
                onSelect={() => {
                  onChange(retailerClient);
                }}
              >
                {retailerClient.label}
              </Menu.Item>
            );
          })}
        </Menu.List>
      </Menu>
    </div>
  );
};

export default MultiBannerRetailerSelector;
